import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, Table } from "react-bootstrap";
import { loadAllQuests } from "../../lib/api/quest";
import { EmptyBlank } from "../../components/common";

const QuestItem = ({ num, _id, info, building, game, onClickEdit }) => {
  return (
    <tr>
      <td>{num}</td>
      <td>{building.name}</td>
      <td>{game.name}</td>
      <td>
        {building.position.latitude} : {building.position.longitude}
      </td>
      <td>{info.gpsMeter}</td>
      <td>
        <Button onClick={onClickEdit} id={_id} size="sm">
          수정
        </Button>
      </td>
    </tr>
  );
};

const Home = () => {
  const navigate = useNavigate();
  const [quests, setQuests] = useState([]);

  const requestAllQuests = useCallback(async () => {
    const { status, quests } = await loadAllQuests();
    //console.log("status => ", status);
    //console.log("quests => ", quests);
    setQuests(quests);
  }, []);

  useEffect(() => {
    requestAllQuests();
  }, [requestAllQuests]);

  const handleEdit = (e) => {
    const { id } = e.target;
    const quest = quests.find((x) => x._id === id);
    if (quest) {
      navigate(`/quests/${id}/edit`);
    }
  };

  return (
    <div>
      <Container fluid="md">
        <Table variant="striped">
          <thead>
            <tr>
              <th>#</th>
              <th>건물</th>
              <th>미니 게임</th>
              <th>GPS</th>
              <th>GPS 범위</th>
              <th style={{ visibility: "hidden" }}>수정</th>
            </tr>
          </thead>
          <tbody>
            {quests
              ? quests.map((it, index) => (
                  <QuestItem
                    key={index}
                    {...it}
                    num={index + 1}
                    onClickEdit={handleEdit}
                  />
                ))
              : undefined}
          </tbody>
        </Table>
        <br />
        <EmptyBlank />
      </Container>
    </div>
  );
};

export default Home;
